export default {
	styleOverrides: {
		input: {
			lineHeight: '160%',
			padding: '12.5px 16px',
		},
		root: {
			overflow: 'hidden',
		},
		notchedOutline: {
			border: 0,
		},
	},
};
